import { withMessage } from 'io-ts-types';
import * as tt from 'io-ts-types';

export default withMessage(tt.NonEmptyString, () => 'VALIDATION_REQUIRED');
